import { PAGES } from "@dune/types";
import { MaterialToSubmissionFormData } from "@dune/types";
import { useEffect } from "react";
import { FormProvider } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import { useUpdateMaterialParticipant } from "../../../../api/mutations/constructionSiteSubmission.mutations";
import { MaterialToSubmissionForm } from "../../../../component/constructionSites/submission/participants/MaterialToSubmissionForm";
import PageLayoutWithTabs from "../../../../component/layout/PageLayoutWithTabs";
import { useEntityPanelSync } from "../../../../hooks/useEntityPanelSync";
import { useMaterialToSubmissionForm } from "../../../../hooks/useParticipantToSubmissionForm";

export const EditMaterialToSubmissionPage = () => {
	const navigate = useNavigate();
	const { constructionSiteId, participantId } = useParams<{
		constructionSiteId: string;
		participantId: string;
	}>();

	const updateMaterialMutation = useUpdateMaterialParticipant(
		constructionSiteId ? Number(constructionSiteId) : 0,
		participantId ? Number(participantId) : 0,
	);

	const onSubmit = (data: MaterialToSubmissionFormData) => {
		updateMaterialMutation.mutate(data, {
			onSuccess: () => {
				if (constructionSiteId) {
					navigate(
					PAGES.PROJECTS.submission.withParams(constructionSiteId, 4),
					{ replace: true },
				);
				}
			},
		});
	};

	const onCancel = () => {
		if (constructionSiteId) {
					navigate(
					PAGES.PROJECTS.submission.withParams(constructionSiteId, 4),
					{ replace: true },
				);
		}
	};

	const { form, handleSubmit } = useMaterialToSubmissionForm({
		mode: "update",
		onSubmit,
		constructionSiteId: constructionSiteId
			? Number(constructionSiteId)
			: undefined,
		participantId: participantId ? Number(participantId) : undefined,
	});

	useEntityPanelSync({
		entityType: "CONSTRUCTION_SITE",
		entityId: constructionSiteId ? Number(constructionSiteId) : 0,
	});

	useEffect(() => {
		if (!constructionSiteId || !participantId) {
			navigate(PAGES.PROJECTS.index);
		}
	}, [constructionSiteId, participantId, navigate]);

	if (!constructionSiteId || !participantId) {
		return null;
	}

	return (
		<PageLayoutWithTabs title="Modifier un matériau">
			<FormProvider {...form}>
				<form onSubmit={handleSubmit}>
					<MaterialToSubmissionForm
						constructionSiteId={Number(constructionSiteId)}
						onSubmit={handleSubmit}
						onCancel={onCancel}
						isSubmitting={updateMaterialMutation.isPending}
					/>
				</form>
			</FormProvider>
		</PageLayoutWithTabs>
	);
};
